import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CustomerActionsMenu = ({ customer, onViewProfile, onEdit, onDelete, onSendStatement, onViewPayments }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleAction = (action) => {
    setIsOpen(false);
    action(customer);
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        iconName="MoreVertical"
      />

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-card rounded-lg shadow-lg border border-border z-20">
            <div className="py-1">
              <button
                onClick={() => handleAction(onViewProfile)}
                className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
              >
                <Icon name="Eye" size={16} />
                View Profile
              </button>
              <button
                onClick={() => handleAction(onViewPayments)}
                className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
              >
                <Icon name="CreditCard" size={16} />
                View Payments
              </button>
              <button
                onClick={() => handleAction(onEdit)}
                className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
              >
                <Icon name="Edit" size={16} />
                Edit Customer
              </button>
              <button
                onClick={() => handleAction(onSendStatement)}
                className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
              >
                <Icon name="FileText" size={16} />
                Statement
              </button>
              <div className="border-t border-border my-1" />
              <button
                onClick={() => handleAction(onDelete)}
                className="w-full px-4 py-2 text-left text-sm text-error hover:bg-error/10 transition-smooth flex items-center gap-2"
              >
                <Icon name="Trash2" size={16} />
                Delete Customer
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomerActionsMenu;